// TODO: create rotateKnobs dynamically when earrings added to ear

import EarCanvas from "earcanvas";
import DragDrop from "ds-dragdrop";
import { Color } from "three";
import Rotator from "ds-rotator";
import * as dat from "dat.gui";
import mobile from "is-mobile";
import "./index.scss";
// import models from './assets/models.json';

let zonesCurrent;
let count = 0;
let earrings = {};
let dndScale = 1;
window.earrings = earrings;
const savedEarrings = {};
window.savedEarrings = savedEarrings;
let current = null;
window.current = current;

let earcanvas = null;
let dragdrop;
let earringContainer;
let errorMessage;
const gui = new dat.GUI({
  // load: cachedSettings,
});
window.gui = gui;
const showError = (message) => {
  if (earcanvas) earcanvas.cancelPrepareItem();
  errorMessage.innerText = message;
  errorMessage.classList.remove("hidden");
  setTimeout(() => {
    errorMessage.classList.add("hidden");
  }, 2000);
};
// const DivotsSettings = gui.addFolder("Divots");
const diamondSettings = gui.addFolder("Diamond Shader");
// const WopalSettings = gui.addFolder("White Opal Shader");
// const LLSettings = gui.addFolder("Lapis Lazuli Shader");
// const TQsettings = gui.addFolder("Turqoise Shader");
// const TESettings = gui.addFolder("Tiger's Eye Shader");
// const PESettings = gui.addFolder("Pearl Shader");
// const BMSettings = gui.addFolder("Black Moissanite Shader");
// const metalSettings = gui.addFolder("Metal Shaders");
const diamondShader = {
  dispersion: 0,
  color: { r: 0, g: 0, b: 0 },
  squashFactor: 0,
  envMapIntensity: 2.688,
  refractiveIndex: 3.462,
  gammaFactor: 0,
  absorbptionFactor: 0,
  reflectivity: 0.5,
  envMapRotation: 0.0,
};
const allZones = [
  "Conch",
  "ConchContra",
  "Daith",
  "Earlobe",
  "Helix",
  "HelixForward",
  "HelixTash",
  "Rook",
  "RookTash",
  "RookTashHidden",
  "Tragus",
  "TragusAnti",
];

const init = () => {
  const app = document.querySelector(".app");
  const container = document.querySelector("#tryon-container");
  const saveButton = document.querySelector("#save");
  const restoreButton = document.querySelector("#restore");
  const resetButton = document.querySelector("#reset");
  const zoomButton = document.querySelector("#zoom");
  const resetZoomButton = document.querySelector("#resetZoom");
  const imageButtons = Array.from(
    document.querySelector("#image-buttons").children
  );
  const screenshots = document.querySelector("#screenshots");
  const controls = document.querySelector("#controls");
  const controlsToggle = document.querySelector("#controlstoggle");
  const earringMetals = document.querySelector("#earrings-metals");
  const dragdropButton = document.querySelector("#dragdrop");
  const loadmoreButton = document.querySelector("#loadmore");
  const filterButton = document.querySelector("#filter");

  dragdropButton.addEventListener("click", () => {
    const value = dragdropButton.getAttribute("data-value") !== "true";
    dragdropButton.setAttribute("data-value", value);
    dragdropButton.innerText = `DragDrop: ${value ? "on" : "off"}`;
    dragdrop[value ? "listen" : "unlisten"]();
  });
  document.getElementById("earrings-buttons").innerHTML = "";
  loadJSONData();

  const earringButtons = Array.from(document.querySelectorAll("[data-file]"));
  earringButtons.forEach((button) => {
    const zoneSelector = document.createElement("select");
    zoneSelector.draggable = false;
    const title = document.createElement("option");
    title.innerText = "place in zone:";
    zoneSelector.appendChild(title);
    allZones.forEach((zone) => {
      const option = document.createElement("option");
      option.innerText = zone;
      option.value = zone;
      zoneSelector.appendChild(option);
    });
    button.appendChild(zoneSelector);
    zoneSelector.addEventListener("change", () => {
      const id = `earring_${count}`;
      count++;
      const model = button.getAttribute("data-file");
      const type = button.getAttribute("data-type");
      const charmHeight = button.getAttribute("data-charmHeight");
      const zone = zoneSelector.value;
      const zones = [zone];
      const active = false;
      app.classList.add("loading");

      earcanvas
        .addItem(id, { id, model, type, zone, zones, active, charmHeight })
        .then((res) => {
          console.log(res);
          app.classList.remove("loading");
          if (res.error) return showError(res.error);
          earrings[res.id] = { id: res.id };
          savedEarrings[res.id] = earcanvas.state.items[res.id];
        });
    });
  });

  errorMessage = document.createElement("div");
  errorMessage.className = "errormessage hidden";
  app.appendChild(errorMessage);
  try {
    earcanvas = new EarCanvas(container, {
      resize: true,
      debug: false,
      controls: true,
      quality: "high",
    });
  } catch (e) {
    showError(e.error);
  }
  if (!earcanvas) return;
  earcanvas.element.addEventListener("ready", () => {
    app.classList.add("ready");
  });
  earcanvas.element.addEventListener("failed", (res) => {
    console.log(res.detail.message);
  });
  earcanvas.element.addEventListener("loaded", () => {
    console.log("Loaded");
  });
  earcanvas.element.addEventListener("earcolorchanged", () => {
    console.log("earcolorchanged");
  });
  earcanvas.element.addEventListener("activeItemChanged", () => {
    console.log("earcolorchanged");
  });
  earcanvas.element.addEventListener("itemDeleted", (res) => {
    delete savedEarrings[res.detail.itemID];
    console.log("itemDeleted", res.detail.itemID);
    // console.log("new savedEarrings", savedEarrings);
  });
  earcanvas.element.addEventListener("itemMoved", (res) => {
    savedEarrings[res.detail.itemID] = earcanvas.state.items[res.detail.itemID];
    console.log("itemMoved", res.detail.itemID);
    // console.log("new savedEarrings", savedEarrings);
  });
  earcanvas.element.addEventListener("loading", (res) => {
    console.log(
      res.detail.message,
      res.detail.itemsLoaded / res.detail.itemsTotal
    );
  });
  earcanvas.element.addEventListener("leaveCanvas", (res) => {
    showError(res.detail.error);
  });

  earcanvas.element.addEventListener("errorZone", (res) => {
    showError(res.detail.error);
  });
  const rotateKnob = document.createElement("div");
  rotateKnob.className = "knob hidden";

  const rotateKnobHandle = document.createElement("span");
  rotateKnobHandle.className = "knob-handle hidden";

  rotateKnob.appendChild(rotateKnobHandle);
  const rotator = new Rotator(rotateKnob);
  rotator.element.addEventListener("rotated", (e) => {
    console.log("Rotator");
    earcanvas.rotateItem(current, -e.detail);
  });
  container.appendChild(rotateKnob);

  const rotateKnob2 = document.createElement("div");
  rotateKnob2.className = "knob hidden";
  container.appendChild(rotateKnob2);

  controlsToggle.addEventListener("click", () => {
    controls.classList[
      controls.classList.contains("active") ? "remove" : "add"
    ]("active");
  });

  loadmoreButton.addEventListener("click", () => {
    Array.from(
      document.querySelector("#earrings-buttons-extras").children
    ).forEach((button) => {
      earringContainer.appendChild(button);
    });
  });

  filterButton.addEventListener("click", () => {
    const earringButtons = Array.from(
      document.querySelector("#earrings-buttons").children
    );
    earringButtons[Math.floor(Math.random(earringButtons.length))].remove();
    // console.log(earringButtons);
  });

  earcanvas.element.addEventListener("itemMoved", (e) => {
    const { x, y } = e.detail.position2D;
    // const position2 = e.detail.positions2D[1];
    // console.log(position2D2.y, y);
    rotateKnob.style.left = x;
    rotateKnob.style.top = y;
    rotateKnob.classList.remove("hidden");
    // console.log("show knob");

    // if (position2) {
    //   rotateKnob2.style.left = position2.x;
    //   rotateKnob2.style.top = position2.y;
    //   rotateKnob2.classList.remove('hidden');
    // }
  });

  earcanvas.element.addEventListener("zoomChanged", (e) => {
    console.log("zoomChanged", e.detail);
    dndScale = e.detail.scale;
    if (e.detail.position2D) {
      const { x, y } = e.detail.position2D;
      // const position2 = e.detail.positions2D[1];
      // console.log(position2D2.y, y);
      rotateKnob.style.left = x;
      rotateKnob.style.top = y;
      rotateKnob.classList.remove("hidden");
    } else {
      rotateKnob.classList.add("hidden");
    }
    console.log(`${(e.detail.right - 40)}px`);
    controlsToggle.style.left = `${(e.detail.right - 40)}px`;
  });

  earcanvas.element.addEventListener("itemStartDragging", () => {
    rotateKnob.classList.add("hidden");
  });

  earcanvas.element.addEventListener("itemEndDragging", () => {
    rotateKnob.classList.remove("hidden");
  });

  earcanvas.element.addEventListener("cameraMoved", () => {
    console.log("camera moved");
  });

  earcanvas.element.addEventListener("cameraMoving", () => {
    console.log("camera moving");
  });

  earcanvas.element.addEventListener("activeItemChanged", (e) => {
    current = e.detail.itemID;

    earringMetals.classList[current ? "remove" : "add"]("hidden");
    if (e.detail.itemID) {
      rotator.setRotation(-earcanvas.state.items[e.detail.itemID].rotation);
      rotateKnobHandle.classList[
        earcanvas.state.items[e.detail.itemID].type === "stud"
          ? "remove"
          : "add"
      ]("hidden");
      rotateKnob.style.left =
        earcanvas.state.items[e.detail.itemID].position2D.x;
      rotateKnob.style.top =
        earcanvas.state.items[e.detail.itemID].position2D.y;
    }
  });

  saveButton.addEventListener("click", () => {
    // savedEarrings = {};
    Object.keys(savedEarrings).forEach((key) => {
      delete savedEarrings[key];
    });
    Object.keys(earcanvas.state.items).forEach((key) => {
      if (earcanvas.state.items[key]) {
        const {
          sku,
          model,
          type,
          metal,
          position3D,
          position2D,
          side,
          rotation,
          isRotatable,
          zones,
          zone,
          ringDiameter,
          minRingDiameter,
        } = earcanvas.state.items[key];
        savedEarrings[key] = earcanvas.state.items[key];
      }
    });
    // console.log(" saved ", savedEarrings);
  });

  restoreButton.addEventListener("click", () => {
    earcanvas.restore(savedEarrings);
  });

  resetButton.addEventListener("click", () => {
    earcanvas.reset();
    earrings = {};
    // savedEarrings = {};
  });

  zoomButton.addEventListener("click", () => {
    earcanvas.zoomToFit();
  });

  resetZoomButton.addEventListener("click", () => {
    earcanvas.resetZoom();
  });

  imageButtons.forEach((button) => {
    button.addEventListener("click", ({ target }) => {
      earcanvas
        .getImage({
          side: target.getAttribute("data-side"),
          width: 300,
          height: 300,
          quality: 0.75,
          format: "jpg",
        })
        .then((res) => {
          if (res.error) {
            return showError(res.error);
          }
          screenshots.prepend(res.image);
        });
    });
  });

  window.earcanvas = earcanvas;
  window.diamondMaterial = earcanvas.canvas.diamondsClass;

  earringContainer = document.querySelector("#earrings-buttons");

  dragdrop = new DragDrop(earringContainer, container, {
    autoListen: false,
    selector: "img",
    size: { width: 500, height: 500 },
    offset: { x: 0, y: 200 },
  });

  dragdrop.element.addEventListener("dragged", ({ detail }) => {
    const file = detail.getAttribute("data-file");
    const type = detail.getAttribute("data-type");
    dragdrop.state.thumb.style.width = `${dragdrop.options.size.width * dndScale}px`;
    dragdrop.state.thumb.style.height = `${dragdrop.options.size.height* dndScale}px`;
    const charmHeight = detail.getAttribute("data-charmHeight");
    const ringDiameter = detail.getAttribute("data-ringDiameter");
    zonesCurrent = detail
      .getAttribute("data-zones")
      .replace(/\s+/g, "")
      .split(",");
    console.log("charmHeight", charmHeight);
    earcanvas.prepareItem(file, type, zonesCurrent, {
      ringDiameter,
      charmHeight,
    });
    rotateKnob.classList.add("hidden");
  });

  dragdrop.element.addEventListener("dropped", ({ detail }) => {
    if (!detail.inDropZone) {
      earcanvas.cancelPrepareItem();
    } else {
      const id = `earring_${count}`;
      count++;
      const model = detail.element.getAttribute("data-file");
      const type = detail.element.getAttribute("data-type");
      const metal = detail.element.getAttribute("data-metal");
      const isRotatable = detail.element.getAttribute("data-isRotatable");
      const minRingDiameter = detail.element.getAttribute(
        "data-minRingDiameter"
      );
      const ringDiameter = detail.element.getAttribute("data-ringDiameter");
      const charmHeight = detail.element.getAttribute("data-charmHeight");
      const zones = zonesCurrent;
      app.classList.add("loading");

      earcanvas
        .addItem("sku", {
          id,
          model,
          type,
          metal,
          zones,
          charmHeight,
          minRingDiameter,
          ringDiameter,
          isRotatable: isRotatable || false,
        })
        .then((res) => {
          app.classList.remove("loading");
          if (res.error) return showError(res.error);
          earrings[res.id] = { id: res.id };
          savedEarrings[res.id] = earcanvas.state.items[res.id];
        });
    }
  });

  let skintoneActive = null;
  const skintoneButtons = Array.from(
    document.querySelector("#skintone").children
  );
  const skintoneTitle = document.querySelector("#skintone > p");
  skintoneButtons.forEach((button) => {
    if (button.getAttribute("data-color") == earcanvas.state.earColor) {
      button.classList.add("active");
    }
    if (button.classList.contains("active")) {
      skintoneActive = button;
      skintoneTitle.innerHTML = `<span style='font-weight: bold'>Skin Tone:</span> <span>${button.getAttribute(
        "data-name"
      )}</span>`;
    }
    button.addEventListener("click", ({ target }) => {
      earcanvas.changeEarColor(parseInt(target.getAttribute("data-color"), 10));
      if (skintoneActive) skintoneActive.classList.remove("active");
      skintoneActive = target;
      skintoneActive.classList.add("active");
      skintoneTitle.innerHTML = `<span style='font-weight: bold'>Skin Tone:</span> <span>${target.getAttribute(
        "data-name"
      )}</span>`;
    });
  });

  const earViewButtons = Array.from(
    document.querySelector("#ear-view").children
  );
  earViewButtons.forEach((button) => {
    button.addEventListener("click", ({ target }) => {
      earcanvas.changeView(target.getAttribute("data-view"));
    });
  });
  window.addEventListener("keyup", (ev) => {
    if (ev.key === "r") earcanvas.changeView("right");
    if (ev.key === "l") earcanvas.changeView("left");
    if (ev.key === "1") earcanvas.changeEarColor(0);
    if (ev.key === "2") earcanvas.changeEarColor(1);
    if (ev.key === "3") earcanvas.changeEarColor(2);
    if (ev.key === "4") earcanvas.changeEarColor(3);
    if (ev.key === "Backspace") earcanvas.restore(savedEarrings);
    if (ev.key === "Delete") {
      earcanvas.reset();
      earrings = {};
    }
    if (ev.key === "w" && current) {
      earcanvas.changeItemMetal(current, "whitegold18");
    }
    console.log(ev.key);
    console.log(savedEarrings);
  });
  const earringMetalButtons = Array.from(
    document.querySelector("#earrings-metals").children
  );
  earringMetalButtons.forEach((button) => {
    if (button.getAttribute("data-type")) {
      button.addEventListener("click", ({ target }) => {
        if (current) {
          earcanvas.changeItemMetal(current, target.getAttribute("data-type"));
        }
      });
    } else
      button.addEventListener("click", () => {
        earcanvas.deleteItem(current);
      });
  });
  setupControls();
};
function setupControls () {
  diamondSettings
    .add(diamondShader, "envMapIntensity", 0, 10, 0.001)
    .onChange((value) => {
      if (earcanvas.canvas.state.activeItem) {
        earcanvas.canvas.diamondMaterials[
          earcanvas.canvas.state.activeItem
        ].forEach((mat) => {
          mat.uniforms.envMapIntensity.value = value;
        });
      } else {
        Object.keys(earcanvas.canvas.diamondMaterials).forEach((key) => {
          const diamonds = earcanvas.canvas.diamondMaterials[key];
          diamonds.forEach((mat) => {
            mat.uniforms.envMapIntensity.value = value;
          });
        });
      }
      earcanvas.canvas.render(true);
    });

  diamondSettings
    .add(diamondShader, "refractiveIndex", 1, 5, 0.001)
    .onChange((value) => {
      if (earcanvas.canvas.state.activeItem) {
        earcanvas.canvas.diamondMaterials[
          earcanvas.canvas.state.activeItem
        ].forEach((mat) => {
          mat.refractiveIndex = value;
        });
      } else {
        Object.keys(earcanvas.canvas.diamondMaterials).forEach((key) => {
          const diamonds = earcanvas.canvas.diamondMaterials[key];
          diamonds.forEach((mat) => {
            mat.refractiveIndex = value;
          });
        });
      }
      earcanvas.canvas.render(true);
    });

  diamondSettings
    .add(diamondShader, "squashFactor", 0.1, 1, 0.001)
    .onChange((value) => {
      if (earcanvas.canvas.state.activeItem) {
        earcanvas.canvas.diamondMaterials[
          earcanvas.canvas.state.activeItem
        ].forEach((mat) => {
          mat.squashFactor = value;
        });
      } else {
        Object.keys(earcanvas.canvas.diamondMaterials).forEach((key) => {
          const diamonds = earcanvas.canvas.diamondMaterials[key];
          diamonds.forEach((mat) => {
            mat.squashFactor = value;
          });
        });
      }
      earcanvas.canvas.render(true);
    });

  diamondSettings.add(diamondShader, "gammaFactor", 1, 2).onChange((value) => {
    if (earcanvas.canvas.state.activeItem) {
      earcanvas.canvas.diamondMaterials[
        earcanvas.canvas.state.activeItem
      ].forEach((mat) => {
        mat.gammaFactor = value;
      });
    } else {
      Object.keys(earcanvas.canvas.diamondMaterials).forEach((key) => {
        const diamonds = earcanvas.canvas.diamondMaterials[key];
        diamonds.forEach((mat) => {
          mat.gammaFactor = value;
        });
      });
    }

    earcanvas.canvas.render(true);
  });

  diamondSettings
    .add(diamondShader, "absorbptionFactor", 1, 5, 0.01)
    .onChange((value) => {
      if (earcanvas.canvas.state.activeItem) {
        earcanvas.canvas.diamondMaterials[
          earcanvas.canvas.state.activeItem
        ].forEach((mat) => {
          mat.absorbptionFactor = value;
        });
      } else {
        Object.keys(earcanvas.canvas.diamondMaterials).forEach((key) => {
          const diamonds = earcanvas.canvas.diamondMaterials[key];
          diamonds.forEach((mat) => {
            mat.absorbptionFactor = value;
          });
        });
      }
      earcanvas.canvas.render(true);
    });

  diamondSettings
    .add(diamondShader, "reflectivity", 0.0, 1.0, 0.01)
    .onChange((value) => {
      if (earcanvas.canvas.state.activeItem) {
        earcanvas.canvas.diamondMaterials[
          earcanvas.canvas.state.activeItem
        ].forEach((mat) => {
          mat.uniforms.reflectivity.value = value;
        });
      } else {
        Object.keys(earcanvas.canvas.diamondMaterials).forEach((key) => {
          console.log(key);
          const diamonds = earcanvas.canvas.diamondMaterials[key];
          diamonds.forEach((mat) => {
            mat.uniforms.reflectivity.value = value;
          });
        });
      }
      earcanvas.canvas.render(true);
    });

  diamondSettings
    .add(diamondShader, "envMapRotation", 0.0, 6.28, 0.01)
    .onChange((value) => {
      if (earcanvas.canvas.state.activeItem) {
        earcanvas.canvas.diamondMaterials[
          earcanvas.canvas.state.activeItem
        ].forEach((mat) => {
          mat.uniforms.envMapRotation.value = value;
        });
      } else {
        Object.keys(earcanvas.canvas.diamondMaterials).forEach((key) => {
          const diamonds = earcanvas.canvas.diamondMaterials[key];
          diamonds.forEach((mat) => {
            mat.uniforms.envMapRotation.value = value;
          });
        });
      }
      earcanvas.canvas.render(true);
    });

  diamondSettings.add(diamondShader.color, "r", 0, 255, 1).onChange((value) => {
    if (earcanvas.canvas.state.activeItem) {
      earcanvas.canvas.diamondMaterials[
        earcanvas.canvas.state.activeItem
      ].forEach((mat) => {
        mat.color = new Color(
          `rgb(${Math.floor(value)}, ${Math.floor(
            mat.color.g * 255
          )}, ${Math.floor(mat.color.b * 255)})`
        );
      });
    } else {
      Object.keys(earcanvas.canvas.diamondMaterials).forEach((key) => {
        const diamonds = earcanvas.canvas.diamondMaterials[key];
        diamonds.forEach((mat) => {
          mat.color = new Color(
            `rgb(${Math.floor(value)}, ${Math.floor(
              mat.color.g * 255
            )}, ${Math.floor(mat.color.b * 255)})`
          );
        });
      });
    }
    earcanvas.canvas.render(true);
  });
  diamondSettings.add(diamondShader.color, "g", 0, 255, 1).onChange((value) => {
    if (earcanvas.canvas.state.activeItem) {
      earcanvas.canvas.diamondMaterials[
        earcanvas.canvas.state.activeItem
      ].forEach((mat) => {
        mat.color = new Color(
          `rgb(${Math.floor(mat.color.r * 255)}, ${Math.floor(
            value
          )}, ${Math.floor(mat.color.b * 255)})`
        );
      });
    } else {
      Object.keys(earcanvas.canvas.diamondMaterials).forEach((key) => {
        const diamonds = earcanvas.canvas.diamondMaterials[key];
        diamonds.forEach((mat) => {
          mat.color = new Color(
            `rgb(${Math.floor(mat.color.r * 255)}, ${Math.floor(
              value
            )}, ${Math.floor(mat.color.b * 255)})`
          );
        });
      });
    }

    earcanvas.canvas.render(true);
  });
  diamondSettings.add(diamondShader.color, "b", 0, 255, 1).onChange((value) => {
    if (earcanvas.canvas.state.activeItem) {
      earcanvas.canvas.diamondMaterials[
        earcanvas.canvas.state.activeItem
      ].forEach((mat) => {
        mat.color = new Color(
          `rgb(${Math.floor(mat.color.r * 255)}, ${Math.floor(
            mat.color.g * 255
          )}, ${Math.floor(value)})`
        );
      });
    } else {
      Object.keys(earcanvas.canvas.diamondMaterials).forEach((key) => {
        const diamonds = earcanvas.canvas.diamondMaterials[key];
        diamonds.forEach((mat) => {
          mat.color = new Color(
            `rgb(${Math.floor(mat.color.r * 255)}, ${Math.floor(
              mat.color.g * 255
            )}, ${Math.floor(value)})`
          );
        });
      });
    }
    earcanvas.canvas.render(true);
  });

  diamondSettings.addColor(diamondShader, "color").onChange(({ r, g, b }) => {
    if (earcanvas.canvas.state.activeItem) {
      earcanvas.canvas.diamondMaterials[
        earcanvas.canvas.state.activeItem
      ].forEach((mat) => {
        mat.color = new Color(
          `rgb(${Math.floor(r)}, ${Math.floor(g)}, ${Math.floor(b)})`
        );
      });
    } else {
      Object.keys(earcanvas.canvas.diamondMaterials).forEach((key) => {
        const diamonds = earcanvas.canvas.diamondMaterials[key];
        diamonds.forEach((mat) => {
          mat.color = new Color(
            `rgb(${Math.floor(r)}, ${Math.floor(g)}, ${Math.floor(b)})`
          );
        });
      });
    }
    earcanvas.canvas.render(true);
  });
}
window.addEventListener("load", init);

window.addEventListener("keyup", (ev) => {
  //earcanvas.canvas.renderer.forceContextRestore();
  //this.updateReflections();
});

async function loadJSONData() {
  const response = await fetch("./assets/models.json");
  const jsonData = await response.json();
  for (let item of jsonData.models) {
    const itemDiv = document.createElement("div");
    const itemName = item["data-file"].substring(
      0,
      item["data-file"].indexOf(".")
    );
    const img = document.createElement("img");
    const p = document.createElement("p");
    if (item["data-thumb"] === "")
      item["data-thumb"] = "assets/images/" + itemName + ".png";
    item["data-file"] = "assets/models/" + itemName + ".glb";
    img.src = item.icon;
    p.innerText = itemName;
    itemDiv.appendChild(img);
    itemDiv.appendChild(p);
    Object.keys(item).forEach((key) => {
      itemDiv.setAttribute(key, item[key]);
    });
    document.getElementById("earrings-buttons").appendChild(itemDiv);
  }
}
